import React, { useEffect } from "react";
import { Box, Paper, Typography } from "@mui/material";
import logo from "../../../../../assets/images/logo.svg";
import check from "../../../../assets/images/check.svg";
import ButtonComp from "../../../../components/Button";
import { usePolicyStore } from "../../../../store/usePolicyStore";
import { string } from "../../../../constants/string";

export default function DriverSubmission({onHomeClick}:any) {

  
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      px={2}
    >
      <Box>
        <img
          src={check}
          alt="Logo"
          style={{ height: 200, width: 200, objectFit: "contain" }}
        />
      </Box>

      <Typography fontSize={38} fontWeight={600} gutterBottom>
        {string.driver.heading}
      </Typography>

      <Typography fontSize={30} fontWeight={500} maxWidth={900} mb={4}>
        {string.driver.para}
      </Typography>

      <ButtonComp
        height={40}
        width={200}
        variant="contained"
        onClick={onHomeClick}
      >
        {string.driver.home}
      </ButtonComp>
    </Box>
    
  );
}
